import { Box, Typography } from '@mui/material';
import { useGetIdentity, useGetList, useGetOne, useTranslate } from 'react-admin';

import { GetBoExternalContractsIdEndpoint } from '@Common/types/bo_external/contracts';
import { GetDistributorDetailsEndpoint } from '@Common/types/bo_external/distributor/details';

import { distributorCompanyToAssistanceEmailMapping } from '@sh4res/bo-common/choices/distributor_companies';

import { styles } from '@Components/ContactSupport/styles';

export function DistributorEmails() {
  const translate = useTranslate();

  const { data: identity } = useGetIdentity();

  const { data: esContractData } = useGetList<
    GetBoExternalContractsIdEndpoint['Client']['ResponseBody']
  >('contracts', { filter: { contract_type: ['soles', 'es_custom'] } });
  const { data: erContractData } = useGetList<
    GetBoExternalContractsIdEndpoint['Client']['ResponseBody']
  >('contracts', { filter: { contract_type: ['er_standard', 'er_custom'] } });

  const hasEsContract = Boolean(esContractData?.length);
  const hasErContract = Boolean(erContractData?.length);

  const { data } = useGetOne<GetDistributorDetailsEndpoint['Client']['ResponseBody']>(
    'distributor',
    { id: identity?.id as number },
  );

  if (!data || !esContractData || !erContractData) {
    return;
  }

  const companyEmail: string | undefined =
    distributorCompanyToAssistanceEmailMapping[data.company_name];

  return (
    <Box sx={styles.grid}>
      {companyEmail ? (
        <>
          <Box sx={styles.rowCell}>
            <Typography>{data.company_name}</Typography>
          </Box>
          <Box sx={styles.rowCell}>
            <Typography>{companyEmail}</Typography>
          </Box>
        </>
      ) : (
        <>
          {hasEsContract && (
            <>
              <Box sx={styles.rowCell}>
                <Typography>{translate('contact_support_page.sections.email.es_label')}</Typography>
              </Box>
              <Box sx={styles.rowCell}>service.relationentreprise@axa.fr</Box>
            </>
          )}

          {hasErContract && (
            <>
              <Box sx={styles.rowCell}>
                <Typography>{translate('contact_support_page.sections.email.er_label')}</Typography>
              </Box>
              <Box sx={styles.rowCell}>service.retraitecollective@axa.fr</Box>
              {data.collective_inspector_email && (
                <>
                  <Box sx={styles.rowCell}>
                    <Typography>
                      {translate('contact_support_page.sections.email.inspector_label')}
                    </Typography>
                  </Box>
                  <Box sx={styles.rowCell}>{data.collective_inspector_email}</Box>
                </>
              )}
            </>
          )}
        </>
      )}
    </Box>
  );
}
